import { Pipe, PipeTransform } from '@angular/core';
import { Reservation, ReservationStatus } from '../model/reservation';
import { Common } from './common-methods';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(items: any[], groupByKey: string | undefined, noGrouping: boolean, callback: (a: any, b: any, ...args: any[]) => -1 | 0 | 1, init?: (items: any[]) => any[], ...args: any[]): any {
    if (!items || !callback) {
      return items;
    }

    // reinit sorting order
    if (init != null) {
      items = init(items);
    }

    // without grouping
    if (Common.isNullOrEmpty(groupByKey) || noGrouping) {
      items.sort((a, b) => callback(a, b, args));
      return items;
    }

    // with grouping
    const grouped: { [id: string]: Reservation[]; } = items.reduce((rv, x) => {
      (rv[this.accessMember(x, groupByKey as string)] = rv[this.accessMember(x, groupByKey as string)] || []).push(x);
      return rv;
    }, {});

    for (let [key, value] of Object.entries(grouped)) {
      value.sort((a, b) => callback(a, b, args));
    }

    return Object.entries(grouped)
      .sort((a, b) => {

        const statusA = Common.getStatusIndex(a[0] as ReservationStatus);
        const statusB = Common.getStatusIndex(b[0] as ReservationStatus);

        if (statusA > statusB) {
          return 1;
        }

        if (statusA < statusB) {
          return -1;
        }

        return 0;
      })
      .map(group => group[1])
      .flat();
  }

  accessMember(obj: any, path: string): any {
    const parts = path.split(".");
    if (parts.length == 1) {
      return obj[parts[0]];
    }
    return this.accessMember(obj[parts[0]], parts.slice(1).join("."));
  }

}
